import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getStudyFlow = asyncThunkWrapper({ 
  model: 'studyFlow', 
  action: 'getStudyFlow', 
  func: async () => {
    const attributes = ['id', 'send_at', 'time_zone', 'prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/study_flow`, { params });

    return response.data;
  } 
});
export const createStudyFlow = asyncThunkWrapper({ 
  model: 'studyFlow', 
  action: 'createStudyFlow', 
  func: async (study_flow) => {
    const attributes = ['id', 'send_at', 'time_zone', 'prompt', 'updated_at'];
    const response = await axios.post(`/study_flow`, { study_flow, attributes });

    return response.data;
  } 
});
export const updateStudyFlow = asyncThunkWrapper({ 
  model: 'studyFlows', 
  action: 'updateStudyFlow', 
  func: async (study_flow) => {
    const response = await axios.patch(`/study_flow`, { study_flow });

    return { status: response.status, study_flow };
  } 
});
export const deleteStudyFlow = asyncThunkWrapper({ 
  model: 'studyFlow', 
  action: 'deleteStudyFlow', 
  func: async () => {
    const response = await axios.delete(`/study_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveStudyFlow = createAction('studyFlow/clearLocalActiveStudyFlow');